import cube1 from "./gold1.png";
import cube2 from "./silver1.png";
import cube3 from "./platinum1.png";
import cube4 from "./silver2.png";
import banner from "./banner.png";
// import cube6 from "./silver3.png";
// import cube7 from "./platinum2.png";
// import cube8 from "./black1.png";
// import cube9 from "./platinum3.png";
// import cube10 from "./silver4.png";
// import cube11 from "./gold3.png";
// import cube12 from "./silver5.png";
// import cube13 from "./platinum4.png";
// import cube14 from "./silver6.png";
// import cube15 from "./gold4.png";

export default function QueenDisplay() {
  return (
    <div className="displayDiv">
      <div className="textHolder">
        <h3>
          <span className="gradTextFancyFontWhite">
            Just spreading love for free on this Valentines ? Feels too good to
            be true ?{" "}
          </span>
        </h3>
        <h1>❤️</h1>
      </div>

      {/* <h2 className="gradTextFancyFontGreyRevealingTwitter">
        - Games of Numbers // Get your card today{" "}
      </h2> */}

      {/* <div className="imageHolder">
        <img alt=" " className="reducedSampleImage2" src={cube6} />
        <img alt=" " className="reducedSampleImage2" src={cube7} />
        <img alt=" " className="reducedSampleImage2" src={cube8} />
        <img alt=" " className="reducedSampleImage2" src={cube9} />
        <img alt=" " className="reducedSampleImage2" src={cube10} />
      </div>

    */}
      <div className="imageHolder">
        <img alt=" " className="reducedSampleImage2" src={banner} />
      </div>
    </div>
  );
}
